import { createContext } from 'react'

/**
 * ComponentRequest context for sharing communication and configuration data across components.
 * - Use with useContext(ComponentRequest) to access or provide request-related state.
 */
const ComponentRequest = createContext()

export { ComponentRequest }
